import React from 'react'
import PropTypes from 'prop-types'

// Outlined pen glyph from the DS (Figma 724:7067); inlined because
// FontAwesome Free has no regular-weight pen. Sizes with 1em and inherits
// The current text color.
const PEN_PATH = 'M12.0777 0.823323C11.0709 -0.274441 9.43199 -0.274441 8.42516 0.823323L1.56087 8.3'
  + '1165C1.49221 8.38656 1.44664 8.47477 1.4152 8.56789C1.41328 8.57419 1.4075 8.57839'
  + ' 1.40558 8.58469L0.0329742 13.078C-0.0440301 13.3293 0.0162898 13.6072 0.188266 13'
  + '.7942C0.31019 13.9279 0.474465 14 0.64195 14C0.70997 14 0.778632 13.9881 0.844728 '
  + '13.9636L4.96253 12.4654C4.96831 12.4633 4.97216 12.4577 4.97729 12.4556C5.06328 12'
  + '.422 5.14413 12.3716 5.2128 12.2966L12.0777 4.80902C13.0852 3.71056 13.0852 1.9217'
  + '9 12.0777 0.823323ZM7.5056 3.80577L7.97212 4.31475C7.97083 4.31615 7.96891 4.31685'
  + ' 7.96763 4.31825L3.38779 9.3142L2.92256 8.80662L7.5056 3.80577ZM1.65648 12.193L2.2'
  + '9498 10.1025L3.57196 11.4957L1.65648 12.193ZM4.75975 10.8117L4.29452 10.3041L8.874'
  + '35 5.3082C8.87563 5.3068 8.87628 5.3047 8.87756 5.3033L9.34343 5.81157L4.75975 10.'
  + '8117ZM11.1704 3.81907L10.2514 4.82162L8.41297 2.81582L9.33188 1.81327C9.83883 1.26'
  + '019 10.6634 1.26089 11.1697 1.81327C11.6773 2.36635 11.6773 3.26599 11.1704 3.8190'
  + '7Z'

const PenIcon = ({ className = '' }) => (
  <svg
    aria-hidden="true"
    className={className}
    fill="none"
    height="1em"
    viewBox="0 0 12.8333 14"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d={PEN_PATH} fill="currentColor" />
  </svg>
)

PenIcon.propTypes = {
  className: PropTypes.string
}

PenIcon.defaultProps = {
  className: ''
}

export default PenIcon
